import { API } from 'aws-amplify'

export default () => {
  const query = `query myDocuments {
        myDocuments(limit: "100") {
          data {
            mpID
            documentOf
            relatedItem
            format
            title
          }
        }
      }
      `

  return API.graphql({
    query,
  })
}
